import { useRef } from "react"
import { FormikProps } from "formik"
import { useNavigate, useSearchParams } from "react-router-dom"
import { SupplierPosSettingsTemplates } from "../components/SupplierPosSettingsTemplates"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import {
    SUPPLIER_ADMIN_POS_SETTINGS_CREATE_TEMPLATE_ROUTE,
    SUPPLIER_ADMIN_ROUTE,
} from "../../../../../../constants/routes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { SupplierPosSettingsGeneral } from "../components/SupplierPosSettingsGeneral"
import { StandardTabs } from "../../../../../../shared/components/tabs/StandardTabs"
import { TAB_QUERY_PARAM } from "../../../../../../shared/hooks/useTabQueryParam"
import { UpdateGeneralSettings } from "../supplierPosSettingsTypes"

export function SupplierPosSettings() {
    const navigate = useNavigate()
    const { l10n } = useAppLocalization()
    const [searchParams] = useSearchParams()
    const currentTab = searchParams.get(TAB_QUERY_PARAM)

    const generalSettingsRef = useRef<FormikProps<UpdateGeneralSettings>>(null)

    const handleSaveClick = () => {
        if (generalSettingsRef.current) {
            generalSettingsRef.current?.submitForm()
        }
    }

    const tabs = [
        {
            label: l10n.getString("supplier-admin-pos-settings-tab-templates"),
            component: <SupplierPosSettingsTemplates />,
        },
        { label: l10n.getString("supplier-admin-pos-settings-tab-general"), component: <SupplierPosSettingsGeneral /> },
    ]

    return (
        <>
            <LocalizedStrict id="supplier-admin-pos-settings-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPLIER_ADMIN_POS_SETTINGS}
                    title="POS settings"
                    rightElement={
                        currentTab === "0" || currentTab === null ? (
                            <LocalizedStrict id="supplier-admin-pos-settings-create-button">
                                <StandardButton
                                    onClick={() => navigate(SUPPLIER_ADMIN_POS_SETTINGS_CREATE_TEMPLATE_ROUTE)}
                                >
                                    Create
                                </StandardButton>
                            </LocalizedStrict>
                        ) : (
                            <LocalizedStrict id="supplier-admin-pos-settings-general-submit-button">
                                <StandardButton type="submit" onClick={handleSaveClick}>
                                    Save
                                </StandardButton>
                            </LocalizedStrict>
                        )
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="supplier-nav-item-home">
                            <BreadcrumbLink to={SUPPLIER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-settings">
                            <Breadcrumb>Settings</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-pos-settings">
                            <Breadcrumb>POS settings</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <StandardTabs tabs={tabs} />
        </>
    )
}
